import { LocationContact } from '@hakimo-ui/hakimo/types';
import { MultiSelect } from '@hakimo-ui/hakimo/ui-elements';
import { Alert } from '@hakimo-ui/shared/ui-base';
import { useCallback, useMemo } from 'react';
import { canReceiveSms, SMSAlert } from './sms-util';

interface Props {
  primary: LocationContact;
  selectableContacts: LocationContact[];
  extraRecipients: LocationContact[];
  alerts: SMSAlert[];
  onChange: (recipients: LocationContact[]) => void;
}

export function SMSRecipients(props: Props) {
  const { primary, selectableContacts, extraRecipients, alerts, onChange } =
    props;

  const chosenIds = useMemo(
    () => new Set([primary, ...extraRecipients].map((r) => String(r.id))),
    [primary, extraRecipients]
  );

  const eligible = useMemo(
    () =>
      selectableContacts.filter(
        (c) => canReceiveSms(c) && String(c.id) !== String(primary.id)
      ),
    [selectableContacts, primary.id]
  );

  const getContactOptions = useCallback(
    (query: string): LocationContact[] => {
      const q = query.toLowerCase();
      return eligible.filter(
        (c) =>
          !chosenIds.has(String(c.id)) &&
          `${c.name} ${c.phoneNumber}`.toLowerCase().includes(q)
      );
    },
    [eligible, chosenIds]
  );

  return (
    <div>
      <div className="mb-4">
        <span>
          To: {primary.name}{' '}
          <span className="text-xs">{primary.phoneNumber}</span>
        </span>
      </div>
      {alerts.map((a) => (
        <div key={a.message} className="pb-3">
          <Alert type={a.type}>{a.message}</Alert>
        </div>
      ))}
      {eligible.length > 0 && (
        <div className="mb-3">
          <MultiSelect<LocationContact>
            label="Additional contacts"
            value={extraRecipients}
            onChange={onChange}
            getItems={getContactOptions}
            displayValue={(r) => `${r.name} (${r.phoneNumber})`}
            id={(r) => String(r.id)}
          />
        </div>
      )}
    </div>
  );
}

export default SMSRecipients;
